import { pushDataLayerEvent } from "./index";
import { SuperProperties } from "./super-properties.utils";

type PropertiesToRemoveEventPayload = SuperProperties | SuperProperties[];

export const pushRemoveContextPropertiesEvent = (params: PropertiesToRemoveEventPayload) => {
  pushDataLayerEvent({
    event: "remove_context_properties",
    event_params: { properties_to_remove: params },
  });
};

export const pushRemoveGemCamSuperPropertiesEvent = () => {
  pushRemoveContextPropertiesEvent([
    "gemcam:device_name",
    "gemcam:serial_number",
    "turntable:type",
    "turntable:device_name",
  ]);
};
